// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import BankDetailsActionType from './bank-details.types';

const INITIAL_STATE = {
	// Bank Response
	bankResponse: null,
	// Bank IFSC Code
	bankISFCcode: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** BANK DETAILS CREATE START *********************** */
		case BankDetailsActionType.BANK_DETAILS_CREATE_SUCCESS:
			return { ...state, bankResponse: action.payload };

		case BankDetailsActionType.BANK_DETAILS_CREATE_FAILURE:
			return { ...state, bankResponse: action.payload };

		case BankDetailsActionType.BANK_DETAILS_CREATE_RESPONSE_CHANGED:
			return { ...state, bankResponse: null };
		/** ***************** BANK DETAILS CREATE END *********************** */

		/** ***************** BANK IFSC CODE RESPONSE START *********************** */
		case BankDetailsActionType.BANK_IFSC_CODE_RESPONSE_SUCCESS:
			return { ...state, bankISFCcode: action.payload };

		case BankDetailsActionType.BANK_IFSC_CODE_RESPONSE_FAILURE:
			return { ...state, bankISFCcode: action.payload };

		case BankDetailsActionType.BANK_IFSC_CODE_RESPONSE_CHANGED:
			return { ...state, bankISFCcode: null };
		/** ***************** BANK IFSC CODE RESPONSE END *********************** */

		default:
			return state;
	}
};
